import AFFILIATE from './affiliate';
import AGENCY from './agency';
import DICTIONARY from './dictionary';
import EXPERIENCE from './experience';
import PRICE from './price';
import STORY from './story';
import STORY_PAGE from './storyPage';

export default {
  AFFILIATE,
  AGENCY,
  DICTIONARY,
  EXPERIENCE,
  PRICE,
  STORY,
  STORY_PAGE,
};
